import {Button, Stack, Typography} from "@mui/joy";
import {FormInput} from "@/components/forms/FormInput.jsx";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {newProfile, profileSchema } from "@/features/onboarding/schema.js";
import {useCreateProfileMutation} from "@/features/onboarding/api.js";
import {useNavigate} from "react-router-dom";
import {useAuthState} from "react-firebase-hooks/auth";
import {auth} from "@/features/auth/firebase.js";
import {useEffect} from "react";
import {OnboardingLayout} from "@/features/onboarding/layouts/OnboardingLayout.jsx";
import { FormUnits } from "@/features/units/components/FormUnits";

export function CreateProfilePage() {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [save, saveResult] = useCreateProfileMutation();

  const form = useForm({
    defaultValues: newProfile(),
    resolver: yupResolver(profileSchema),
  });

  useEffect(() => {
    if (user) {
      form.setValue('display_name', user.displayName);
    }
  }, [user]);

  async function onSubmit(data) {
    const result = await save({ data });
    if (result.data?.data?.id) {
      navigate('/onboarding/create-household');
    }
  }

  return (
    <OnboardingLayout
      title="Save money and time"
      subtitle="Plan your meals and groceries and save money and time."
    >      
      <Stack gap={1} sx={{ mb: 3}}>
        <Typography component="h1" level="h2">Who are you?</Typography>
        <Typography level="body-md">
          Tell us a bit about yourself so we can personalize your experience.
        </Typography>
      </Stack>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Stack gap={4}>
            <FormInput name="display_name" label="Display Name" placeholder="Your name" />            
            <FormUnits />
          </Stack>
          <Button loading={saveResult.isLoading} type="submit" size="lg" fullWidth sx={{mt: 4}}>Continue</Button>
        </form>
      </FormProvider>      
    </OnboardingLayout>
  );
}
